import { useState, type FormEvent } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { API_BASE } from "@/config/api";
import { useAdminSession } from "../AdminSessionContext";

export default function AdminLogin() {
  const { status, refresh } = useAdminSession();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (status === "authenticated") {
    return <Navigate to="/admin" replace />;
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const json = await res.json().catch(() => null);
      if (!res.ok) {
        setError(json?.error || "No se pudo iniciar sesión");
        setLoading(false);
        return;
      }
      await refresh();
      navigate("/admin");
    } catch {
      setError("Error de conexión. Inténtalo nuevamente.");
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-primary-950 px-4">
      <div className="w-full max-w-sm rounded-lg bg-background-50 p-8">
        <p className="font-heading font-bold text-lg text-foreground-900">ESPACIO BORMAN</p>
        <p className="text-sm text-foreground-500">Panel de administración</p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          {error && (
            <div className="rounded-md bg-accent-100 border border-accent-200 p-3 text-sm text-accent-800">
              {error}
            </div>
          )}
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
              Email
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-foreground-700 mb-1.5">
              Contraseña
            </label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-md bg-primary-500 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 transition disabled:opacity-60 cursor-pointer"
          >
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>
      </div>
    </div>
  );
}
